import logo from './logo.webp'
import bg from "./bg.webp";
import whatsapp from "./logo-whatsapp.svg";
import Reddit from "./reddit.svg";

import { HeartPulse, Phone } from "lucide-react";
import about_img from "./about_img.webp";

import FoodSecurity from "./tracks/Food Security.webp";
import SustainableFood from "./tracks/Sustainable Food Packaging.webp";
import SmartIrrigationSystems from "./tracks/Smart Irrigation Systems.webp";
import FoodScienceTechnology from "./tracks/Food Science & Technology 1.webp";
import AIFoodProduction from "./tracks/AI in Food Production.webp";
import PlantProteins from "./tracks/Plant-Based Proteins.webp";
import CropSciences from "./tracks/Crop Sciences.webp";
import FoodSafety from "./tracks/Food Safety & Traceability.webp";
import FoodWasteReduction from "./tracks/Food Waste Reduction.webp";
import SoilScience from "./tracks/Soil Science.webp";
import Nutraceuticals from "./tracks/Nutraceuticals.webp";
import ClimateAgriculture from "./tracks/Climate- Smart Agriculture.webp";
import FoodToxicology from "./tracks/Food Toxicology.webp";
import PersonalizedNutrition from "./tracks/Personalized Nutrition 1.webp";
import Agroforestry from "./tracks/Agroforestry.webp";
import IntegratedManagement from "./tracks/Integrated Pest Management.webp";
import AgricultureAquaculture from "./tracks/Agriculture and Aquaculture.webp";
import DairyProduction from "./tracks/Dairy Production.webp";
import Horticulture from "./tracks/Horticulture (1).webp";
import Agrobiodeversity from "./tracks/Agrobiodiversity.webp";

import {
  Facebook,

  Instagram,
  Youtube,
  Linkedin,
  Rss,
  Download,
  Send,
} from "lucide-react";
// import FoodSecurity from "../assets/tracks/Food Security.webp";


import silver from "./badges/2.webp";
import gold from "./badges/3.webp";
import platinum from "./badges/4.webp";
import exhibitor from './badges/1.webp'

import section_banner from "./section_banner.webp";
import { 
  CupStraw, 
  Beaker, 
  Flower, 
  CloudRain, 
  Biohazard, 
  Bug, 
  Box, 
  Cpu, 
  ShieldCheck, 
  Heart, 
  Person, 
  Water, 
  DropletHalf, 
  EggFried, 
  Trash, 
  Sun, 
  Tree, 
  Cheese, 
  Flower2, 
  Globe
} from 'react-bootstrap-icons';
// --------------------------------------icons-----------------
import img1 from "../assets/tracks/img1.webp"
import img2 from "../assets/tracks/img2.webp"
import img3 from "../assets/tracks/img3.webp"
import img4 from "../assets/tracks/img4.webp"
import img5 from "../assets/tracks/img5.webp"
import img6 from "../assets/tracks/img6.webp"
import img7 from "../assets/tracks/img7.webp"
import img8 from "../assets/tracks/img8.webp"
import img9 from "../assets/tracks/img9.webp"
import img10 from "../assets/tracks/img10.webp"
import img11 from "../assets/tracks/img11.webp"
import img12 from "../assets/tracks/img12.webp"
import img13 from "../assets/tracks/img13.webp"
import img14 from "../assets/tracks/img14.webp"
import img15 from "../assets/tracks/img15.webp"
import img16 from "../assets/tracks/img16.webp"
import img17 from "../assets/tracks/img17.webp"
import img18 from "../assets/tracks/img18.webp"
import img19 from "../assets/tracks/img19.webp"
import img20 from "../assets/tracks/img20.webp"


// 
// -----------------------------------------------------------------------------------------
import { IoFastFood } from "react-icons/io5"
import one from "../assets/partners/one.webp";
import two from "../assets/partners/two.webp";
import three from "../assets/partners/three.webp";
import four from "../assets/partners/four.webp";
import five from "../assets/partners/five.webp";
import six from "../assets/partners/six.webp";
import seven from "../assets/partners/seven.webp";
import eight from "../assets/partners/eight.webp";
import nine from "../assets/partners/nine.webp";
export const trackImages = {
  FoodSecurity,
  SustainableFood,
  SmartIrrigationSystems,
  FoodScienceTechnology,
  ClimateAgriculture,
  Nutraceuticals,
  FoodToxicology,
  PersonalizedNutrition,
  Agroforestry,
  IntegratedManagement,
  AgricultureAquaculture,
  DairyProduction,
  SoilScience,
  FoodWasteReduction,
  FoodSafety,
  CropSciences,
  AIFoodProduction,
  PlantProteins,
  Horticulture,
  Agrobiodeversity,
};

export const sticky_links = [
  {
    name: "Brochure",
    icon: Download,
  },
  {
    name: "Upload Abstract",
    icon: Send,
  },
  {
    name: "42098304989",
    icon: Phone,
  },
];
  
  export const RedditIcon = ({ className = "", size = 18 }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className={`ionicon ${className}`}
    viewBox="0 0 512 512"
    width={size}
    height={size}
    fill="currentColor"
  ><path d="M324 256a36 36 0 1036 36 36 36 0 00-36-36z"/><circle cx="188" cy="292" r="36" transform="rotate(-22.5 187.997 291.992)"/><path d="M496 253.77c0-31.19-25.14-56.56-56-56.56a55.72 55.72 0 00-35.61 12.86c-35-23.77-80.78-38.32-129.65-41.27l22-79 66.41 13.2c1.9 26.48 24 47.49 50.65 47.49 28 0 50.78-23 50.78-51.21S441 48 413 48c-19.53 0-36.31 11.19-44.85 28.77l-90-17.89-31.1 109.52-4.63.13c-50.63 2.21-98.34 16.93-134.77 41.53A55.38 55.38 0 0072 197.21c-30.89 0-56 25.37-56 56.56a56.43 56.43 0 0028.11 49.06 98.65 98.65 0 00-.89 13.34c.11 39.74 22.49 77 63 105C146.36 448.77 199.51 464 256 464s109.76-15.23 149.83-42.89c40.53-28 62.85-65.27 62.85-105.06a109.32 109.32 0 00-.84-13.3A56.32 56.32 0 00496 253.77zM414 75a24 24 0 11-24 24 24 24 0 0124-24zM42.72 253.77a29.6 29.6 0 0129.42-29.71 29 29 0 0113.62 3.43c-15.5 14.41-26.93 30.41-34.07 47.68a30.23 30.23 0 01-8.97-21.4zM390.82 399c-35.74 24.59-83.6 38.14-134.77 38.14S157 423.61 121.29 399c-33-22.79-51.24-52.26-51.24-83A78.5 78.5 0 0175 288.72c5.68-15.74 16.16-30.48 31.15-43.79a155.17 155.17 0 0114.76-11.53l.3-.21.24-.17c35.72-24.52 83.52-38 134.61-38s98.9 13.51 134.62 38l.23.17.34.25A156.57 156.57 0 01406 244.92c15 13.32 25.48 28.05 31.16 43.81a85.44 85.44 0 014.31 17.67 77.29 77.29 0 01.6 9.65c-.01 30.72-18.21 60.19-51.25 82.95zm69.6-123.92c-7.13-17.28-18.56-33.29-34.07-47.72A29.09 29.09 0 01440 224a29.59 29.59 0 0129.41 29.71 30.07 30.07 0 01-8.99 21.39z"/><path d="M323.23 362.22c-.25.25-25.56 26.07-67.15 26.27-42-.2-66.28-25.23-67.31-26.27a4.14 4.14 0 00-5.83 0l-13.7 13.47a4.15 4.15 0 000 5.89c3.4 3.4 34.7 34.23 86.78 34.45 51.94-.22 83.38-31.05 86.78-34.45a4.16 4.16 0 000-5.9l-13.71-13.47a4.13 4.13 0 00-5.81 0z"/></svg>
);


export const socialLinks = [
  {
    id: "facebook",
    name: "Facebook",
    url: "https://www.facebook.com/profile.php?id=61576697796195",
    icon: <Facebook size={18} />,
  },
  {
    id: "instagram",
    name: "Instagram",
    url: "https://www.instagram.com/helix_conferences/",
    icon: <Instagram size={18} />,
  },
  {
    id: "youtube",
    name: "YouTube",
    url: "https://www.youtube.com/@Helixconferences",
    icon: <Youtube size={18} />,
  },
  {
    id: "linkedin",
    name: "LinkedIn",
    url: "https://www.linkedin.com/company/helixconferences.com/",
    icon: <Linkedin size={18} />,
  },
  {
    id: "reddit",
    name: "Reddit",
    url: "https://www.reddit.com/user/Salty-Ad6381/",
    icon: <RedditIcon size={18} />,
  },
];
// 
export const WhatsAppIcon = ({ className }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className={`ionicon ${className || ""}`}
    viewBox="0 0 512 512"
    fill="white"
  >
    <path
      d="M414.73 97.1A222.14 222.14 0 00256.94 32C134 32 33.92 131.58 33.87 254a220.61 220.61 0 0029.78 111L32 480l118.25-30.87a223.63 223.63 0 00106.6 27h.09c122.93 0 223-99.59 223.06-222A220.18 220.18 0 00414.73 97.1zM256.94 438.66h-.08a185.75 185.75 0 01-94.36-25.72l-6.77-4-70.17 18.32 18.73-68.09-4.41-7A183.46 183.46 0 0171.53 254c0-101.73 83.21-184.5 185.48-184.5a185 185 0 01185.33 184.64c-.04 101.74-83.21 184.52-185.4 184.52zm101.69-138.19c-5.57-2.78-33-16.2-38.08-18.05s-8.83-2.78-12.54 2.78-14.4 18-17.65 21.75-6.5 4.16-12.07 1.38-23.54-8.63-44.83-27.53c-16.57-14.71-27.75-32.87-31-38.42s-.35-8.56 2.44-11.32c2.51-2.49 5.57-6.48 8.36-9.72s3.72-5.56 5.57-9.26.93-6.94-.46-9.71-12.54-30.08-17.18-41.19c-4.53-10.82-9.12-9.35-12.54-9.52-3.25-.16-7-.2-10.69-.2a20.53 20.53 0 00-14.86 6.94c-5.11 5.56-19.51 19-19.51 46.28s20 53.68 22.76 57.38 39.3 59.73 95.21 83.76a323.11 323.11 0 0031.78 11.68c13.35 4.22 25.5 3.63 35.1 2.2 10.71-1.59 33-13.42 37.63-26.38s4.64-24.06 3.25-26.37-5.11-3.71-10.69-6.48z"
      fillRule=""
    />
  </svg>
);

export {
  logo,
  bg,
  silver,
  gold,
  platinum,
  exhibitor,
  about_img,
  section_banner,
  whatsapp,
  HeartPulse,
};


//   {
//     name: "Food Security",
//     icon: FoodSecurity,
//   },
//   {
//     name: "Food Science & Technology",
//     icon:""
//   },
//   { name: "Crop Sciences", icon: "https://i.ibb.co/Q00qkQz/crop-science.webp" },
//   { name: "Soil Science", icon: "https://i.ibb.co/gLGdj30d/soil-science.webp" },
//   {
//     name: "Food Toxicology",
//     icon: "https://i.ibb.co/rKbk0FRn/food-toxicology.webp",
//   },
//   {
//     name: "Integrated Pest Management",
//     icon: "https://i.ibb.co/fVX2f4t7/integrated-pest-management.webp",
//   },
//   {
//     name: "Sustainable Food Packaging",
//     icon: "https://i.ibb.co/m5NWRBsS/sustainable-food-packaging.webp",
//   },
//   {
//     name: "AI in Food Production",
//     icon: "https://i.ibb.co/tTLctFFL/ai-food-production.webp",
//   },
//   {
//     name: "Food Safety & Traceability",
//     icon: "https://i.ibb.co/gcp3H4z/food-Safety.webp",
//   },
//   {
//     name: "Nutraceuticals",
//     icon: "https://i.ibb.co/b5p0BHy0/nutraceuticals.webp",
//   },
//   {
//     name: "Personalized Nutrition",
//     icon: "https://i.ibb.co/WN3StMmc/personalized-nutrition.webp",
//   },
//   {
//     name: "Agriculture and Aquaculture",
//     icon: "https://i.ibb.co/S4TqPLTL/agriculture-aquaculture.webp",
//   },
//   {
//     name: "Smart Irrigation Systems",
//     icon: "https://i.ibb.co/2YqSdm8M/smart-irrigation.webp",
//   },
//   {
//     name: "Plant-Based Proteins",
//     icon: "https://i.ibb.co/MDQrp937/plant-based-proteins.webp",
//   },
//   {
//     name: "Food Waste Reduction",
//     icon: "https://i.ibb.co/2149vnvc/food-waste.webp",
//   },
//   {
//     name: "Climate- Smart Agriculture",
//     icon: "https://i.ibb.co/zHS3BcBr/climate-smart-agriculture.webp",
//   },
//   { name: "Agroforestry", icon: "https://i.ibb.co/ns2tWG4G/agroforestry.webp" },
//   {
//     name: "Dairy Production",
//     icon: "https://i.ibb.co/4RMBx3MD/dairy-production.webp",
//   },
//   { name: "Horticulture", icon: "https://i.ibb.co/DgHQDD8H/horticulture.webp" },
//   {
//     name: "Agrobiodeversity",
//     icon: "https://i.ibb.co/5ZCb8dL/agrobiodiversity.webp",
//   },
// ];



export const tracks = [
  { name:"Integrated Pest & Disease Management (IPM) Strategies ", icon: img1 },
  { name:"Smart Farming & Digital Agritech", icon:img2 },
  { name:"Climate-Resilient Cropping", icon: img3 },
  { name:"Food Microbiology", icon: img4},
  { name:"Advanced Food Processing & Preservation Technologies", icon: img5 },
  { name:"Nutrition Science & Public Health", icon: img6 },
  { name:"Post-Harvest Technology", icon:img7  },
  { name:"Sustainable Food Packaging", icon: img8 },
  { name:"Environmental Ecology & Restoration Science", icon: img9 },
  { name:"Pollution Monitoring & Control", icon: img10 },
  { name:"Waste Management & Resource Recovery", icon: img11 },
  { name:"Climate Change Science", icon: img12 },
  { name:"Water Resource Management", icon: img13},
  { name:"Environmental Impact Assessment (EIA)", icon:img14},
  { name:"Plant Genetic Improvement & Stress Physiology", icon: img15 },
  { name:"Biofertilizers & Biocontrol Agents", icon:img16},
  { name:"Microbiomes & Ecosystem Functioning", icon:img17 },
  { name:"Bioremediation, Bioenergy & Bio economy Innovations", icon:img18 },
  { name:"AI in Food Production", icon:img19 },
  { name:"Horticulture", icon:img20},
];
export const schedule_plan1 = [
  {
    time: "8:00AM - 9:00AM",
    plan: "Breakfast",
  },
  {
    time: "9:00AM - 9:30AM",
    plan: "Registration",
  },
  {
    time: "9:30AM - 9:45AM",
    plan: "Introduction",
  },
  {
    time: "9:45AM - 10:15AM",
    plan: "KeyNote - 1",
    note: "Slot Available",
  },
  {
    time: "10:15AM - 10:45AM",
    plan: "KeyNote - 2",
  },
  {
    time: "10:45AM - 11:15AM",
    plan: "KeyNote - 3",
  },
  {
    time: "11:15AM - 11:30AM",
    plan: "Refreshment",
  },
  {
    time: "11:30AM - 11:50AM",
    plan: "Oral Presentation - 1",
    note: "Slot Available",
  },
  {
    time: "11:50AM - 12:10PM",
    plan: "Oral Presentation - 2",
  },
  {
    time: "12:10PM - 12:30PM",
    plan: "Oral Presentation - 3",
  },
  {
    time: "12:30PM - 12:50PM",
    plan: "Oral Presentation - 4",
  },
  {
    time: "12:50PM - 1:10PM",
    plan: "Oral Presentation - 5",
  },
  {
    time: "1:10PM - 1:30PM",
    plan: "Oral Presentation - 6",
  },
  {
    time: "1:30PM - 2:00PM",
    plan: "LUNCH",
  },
  {
    time: "2:00PM - 2:20PM",
    plan: "Oral Presentation - 7",
  },
  {
    time: "2:20PM - 2:40PM",
    plan: "Oral Presentation - 8",
  },
  {
    time: "2:40PM - 3:00PM",
    plan: "Oral Presentation - 9",
  },
  {
    time: "3:00PM - 3:20PM",
    plan: "Oral Presentation - 10",
    note: "Slot Available",
  },
  {
    time: "3:20PM - 3:40PM",
    plan: "Oral Presentation - 11",
  },
  {
    time: "3:40PM - 4:00PM",
    plan: "Oral Presentation - 12",
  },
  {
    time: "4:00PM - 4:20PM",
    plan: "Refreshment",
  },
  {
    time: "4:20PM - 4:40PM",
    plan: "Oral Presentation - 13",
  },
  {
    time: "4:40PM - 5:00PM",
    plan: "Oral Presentation - 14",
  },
  {
    time: "5:00PM - 5:20PM",
    plan: "Oral Presentation - 15",
  },
  {
    time: "5:20PM - 5:40PM",
    plan: "Oral Presentation - 16",
  },
  {
    time: "5:40PM - 6:00PM",
    plan: "Oral Presentation - 17",
  },
  {
    time: "6:00PM - 6:20PM",
    plan: "Oral Presentation - 18",
  },
];

export const schedule_plan2 = [
  {
    time: "8:00AM - 9:00AM",
    plan: "Liakou",
  },
  {
    time: "9:00AM - 9:30AM",
    plan: "Liakou",
  },
  {
    time: "9:30AM - 9:45AM",
    plan: "Liakou",
  },
  {
    time: "9:45AM - 10:15AM",
    plan: "Liakou",
  },
  {
    time: "10:15AM - 10:45AM",
    plan: "Liakou",
  },
];

export const schedule_plan3 = [
  {
    time: "8:00AM - 9:00AM",
    plan: "Mohamed Hosni",
  },
  {
    time: "9:00AM - 9:30AM",
    plan: "Mohamed Hosni",
  },
  {
    time: "9:30AM - 9:45AM",
    plan: "Mohamed Hosni",
  },
  {
    time: "9:45AM - 10:15AM",
    plan: "Mohamed Hosni",
  },
  {
    time: "10:15AM - 10:45AM",
    plan: "Mohamed Hosni",
  },
];

export const venueImages = [
  {
    id: 1,
    src: "https://www.valencia-cityguide.com/images/attractions4/cac-vlc.webp", // City of Arts and Sciences at Sunset
    alt: "City of Arts and Sciences",
  },
  {
    id: 2,
    src: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRyyqPwiciv7OKGRrG1V_BTpFhNGoC51fSJ8A&s", // Historic El Carmen District
    alt: "Valencia Cathedral",
  },
  {
    id: 3,
    src: "https://valencia.lbsfilm.at/content/images/size/w2000/2017/11/LBS_BlogOceano_048.webp", // Oceanogràfic Aquarium
    alt: "Oceanogràfic",
  },
  {
    id: 4,
    src: "https://cdn.dreampropertiesvalencia.com/2024/12/district-el-carmen-in-valencia.webp", // El Carmen District
    alt: "El Carmen District",
  },
];

// export const PartnerImageList = [
//   { id: 1, name: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcS9F_PlhWg_-goFeAb__gBJ7HKuALbAYLl4Rg&s" },
//   { id: 2, name: "https://png.pngtree.com/thumb_back/fh260/background/20241007/pngtree-food-harvest-agricultural-gold-rural-bread-cereal-grain-landscape-growth-summer-image_16290734.webp" },
//   { id: 3, name: "https://static.vecteezy.com/system/resources/thumbnails/071/338/275/small/a-table-with-vegetables-and-other-fruits-photo.webp" },
//   { id: 4, name: "https://www.shutterstock.com/shutterstock/videos/3535392427/thumb/1.jpg?ip=x480" },
//   { id: 5, name: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQA3DO2GxOd4gA3QZE8KaJxiLr6L0n_urguEw&s" },
//   { id: 6, name: "https://i.pinimg.com/736x/cb/74/63/cb746371ddf9cb3a317957538a3dc836.webp" },
//   { id: 7, name: "https://www.shutterstock.com/shutterstock/videos/3833711813/thumb/1.jpg?ip=x480" },
//   { id: 8, name: "https://thumbs.dreamstime.com/b/young-potatoes-growing-field-connected-to-drip-irrigation-agriculture-landscape-rural-plantations-farmland-farming-147832280.webp" },
// ];
export const PartnerImageList = [
   { id: 1, name: one },
  { id: 2, name: two },
  { id: 3, name: three },
  { id: 4, name: four },
  { id: 5, name: five },
  { id: 6, name: six },
  { id: 7, name: seven },
  { id: 8, name: eight },
  { id: 9, name: nine },

  // add more local images here
  // { id: 3, name: two },
  // { id: 4, name: three },
];

export const visit_places = [
  {
    name: "Serranos Towers",
    image:
      "https://images.pexels.com/photos/24906254/pexels-photo-24906254/free-photo-of-medieval-serranos-towers-in-valencia.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2",
    km: "2.4",
  },
  {
    name: "Valencia Cathedral",
    image:
      "https://images.pexels.com/photos/21287065/pexels-photo-21287065/free-photo-of-basilica-de-la-mare-deu-dels-desemparats-and-cathedral-in-valencia.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2",
    km: "3.6",
  },
  {
    name: "Gulliver park",
    image:
      "https://images.pexels.com/photos/31978874/pexels-photo-31978874/free-photo-of-tranquil-park-scene-with-fountain-and-trees.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2",
    km: "4.7",
  },
  {
    name: "Oceanogràfic València",
    image:
      "https://images.pexels.com/photos/256150/pexels-photo-256150.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2",
    km: "6",
  },
  {
    name: "City of Arts and Sciences",
    image:
      "https://images.pexels.com/photos/6237137/pexels-photo-6237137.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2",
    km: "6.5",
  },
];
